export default "__VITE_ASSET__DsOkbmIA__"